export const personalCareOffices = [
  {
    name: 'Asheville Assistive Care',
    city: 'Asheville',
    popupId: '#popmake-3208',
    identifier: 'Asheville NC',
    newIdentifier: 'Asheville Assistive Care (Asheville)'
  },
  {
    name: 'Assistive Care Monmouth County',
    city: 'Tinton Falls',
    popupId: '#popmake-2869',
    identifier: 'Assistive Care Monmouth County (Tinton Falls)',
    newIdentifier: 'Assistive Care Monmouth County (Tinton Falls)'
  },
  {
    name: 'Assistive Care of Durham - Chapel Hill',
    city: 'Durham',
    popupId: '#popmake-2769',
    identifier: 'Assistive Care of Durham - Chapel Hill (Durham)',
    newIdentifier: 'Assistive Care of Durham - Chapel Hill (Durham)'
  },
  {
    name: 'Assistive Care of Huntersville',
    city: 'Huntersville',
    popupId: '#popmake-2859',
    identifier: 'Assistive Care of Huntersville (Huntersville)',
    newIdentifier: 'Assistive Care of Huntersville (Huntersville)'
  },
  {
    name: 'Assistive Care of Raleigh',
    city: 'Raleigh',
    popupId: '#popmake-2861',
    identifier: 'Assistive Care of Raleigh (Raleigh)',
    newIdentifier: 'Assistive Care of Raleigh (Raleigh)'
  },
  {
    name: 'Assistive Care of the Triad',
    city: 'Greensboro',
    popupId: '#popmake-2863',
    identifier: 'Assistive Care of the Triad (Greensboro)',
    newIdentifier: 'Assistive Care of the Triad (Greensboro)'
  },
  {
    name: 'Baltimore',
    city: 'Timonium',
    popupId: '#popmake-2857',
    identifier: 'Baltimore',
    newIdentifier: 'Baltimore (Timonium)'
  },
  {
    name: 'Beverly Assistive Care',
    city: 'Beverly',
    popupId: '#popmake-2847',
    identifier: 'Beverly Assistive Care (Beverly)',
    newIdentifier: 'Beverly Assistive Care (Beverly)'
  },
  {
    name: 'Bradenton Florida Assistive Care',
    city: 'Bradenton',
    popupId: '#popmake-3226',
    identifier: 'Bradenton',
    newIdentifier: 'Bradenton Florida Assistive Care (Bradenton)'
  },
  {
    name: 'Braintree Assistive Care',
    city: 'Braintree',
    popupId: '#popmake-2849',
    identifier: 'Braintree Assistive Care (Braintree)',
    newIdentifier: 'Braintree Assistive Care (Braintree)'
  },
  {
    name: 'Burlington',
    city: 'Moorestown',
    popupId: '#popmake-2871',
    identifier: 'Burlington (Moorestown)',
    newIdentifier: 'Burlington (Moorestown)'
  },
  {
    name: 'Charleston Assistive Care',
    city: 'Mount Pleasant',
    popupId: '#popmake-2914',
    identifier: 'Charleston Assistive Care (Mount Pleasant)',
    newIdentifier: 'Charleston Assistive Care (Mount Pleasant)'
  },
  {
    name: 'Charlotte Personal Care',
    city: 'Charlotte',
    popupId: '#popmake-2865',
    identifier: 'Charlotte Personal Care (Charlotte)',
    newIdentifier: 'Charlotte Personal Care (Charlotte)'
  },
  {
    name: 'Cherry Hill Assistive Care',
    city: 'Pennsauken Township',
    popupId: '#popmake-2890',
    identifier: 'Cherry Hill Assistive Care (Cherry Hill)',
    newIdentifier: 'Cherry Hill Assistive Care (Pennsauken Township)'
  },
  {
    name: 'Delaware Assistive Care',
    city: 'Wilmington',
    popupId: '#popmake-2831',
    identifier: 'Delaware Assistive Care (Wilmington)',
    newIdentifier: 'Delaware Assistive Care (Wilmington)'
  },
  {
    name: 'Denver',
    city: 'Denver',
    popupId: '#popmake-2829',
    identifier: 'Denver',
    newIdentifier: 'Denver (Denver)'
  },
  {
    name: 'Downtown Boston Assistive Care',
    city: 'Charlestown',
    popupId: '#popmake-2845',
    identifier: 'Downtown Boston Assistive Care (Charlestown)',
    newIdentifier: 'Downtown Boston Assistive Care (Charlestown)'
  },
  {
    name: 'Essex County Assistive Care',
    city: 'Livingston',
    popupId: '#popmake-2875',
    identifier: 'Essex County Assistive Care (Livingston)',
    newIdentifier: 'Essex County Assistive Care (Livingston)'
  },
  {
    name: 'Fairfax Assistive Care',
    city: 'Fairfax',
    popupId: '#popmake-3221',
    identifier: 'Fairfax',
    newIdentifier: 'Fairfax Assistive Care (Fairfax)'
  },
  {
    name: 'Gloucester Assistive Care',
    city: 'Turnersville',
    popupId: '#popmake-3098',
    identifier: 'Gloucester Assistive Care (Turnersville)',
    newIdentifier: 'Gloucester Assistive Care (Turnersville)'
  },
  {
    name: 'Green Valley',
    city: 'Green Valley',
    popupId: '#popmake-2821',
    identifier: 'Green Valley',
    newIdentifier: 'Green Valley (Green Valley)'
  },
  {
    name: 'Hackensack',
    city: 'Saddle Brook',
    popupId: '#popmake-2819',
    identifier: 'Hackensack',
    newIdentifier: 'Hackensack (Saddle Brook)'
  },
  {
    name: 'Hyannis Assistive Care',
    city: 'Hyannis',
    popupId: '#popmake-2851',
    identifier: 'Hyannis Assistive Care (Hyannis)',
    newIdentifier: 'Hyannis Assistive Care (Hyannis)'
  },
  {
    name: 'Kauai Home Care',
    city: 'Lihue',
    popupId: '#popmake-3115',
    identifier: 'Lihue, HI',
    newIdentifier: 'Kauai Home Care (Lihue)'
  },
  {
    name: 'Las Vegas Assistive Care',
    city: 'Las Vegas',
    popupId: '#popmake-3213',
    identifier: 'Las Vegas NV',
    newIdentifier: 'Las Vegas Assistive Care (Las Vegas)'
  },
  {
    name: 'Linwood Assistive Care',
    city: 'Linwood',
    popupId: '#popmake-2878',
    identifier: 'Linwood Assistive Care (Linwood)',
    newIdentifier: 'Linwood Assistive Care (Linwood)'
  },
  {
    name: 'Long Island Nassau',
    city: 'Garden City',
    popupId: '#popmake-2896',
    identifier: 'Long Island Nassau (Garden City)',
    newIdentifier: 'Long Island Nassau (Garden City)'
  },
  {
    name: 'Long Island Suffolk Assistive Care',
    city: 'Hauppauge',
    popupId: '#popmake-2898',
    identifier: 'Long Island Suffolk Assistive Care (Hauppauge)',
    newIdentifier: 'Long Island Suffolk Assistive Care (Hauppauge)'
  },
  {
    name: 'Lower Bucks Adult',
    city: 'Bensalem',
    popupId: '#popmake-2902',
    identifier: 'Lower Bucks (Bensalem)',
    newIdentifier: 'Lower Bucks Adult (Bensalem)'
  },
  {
    name: 'Main Line Adult',
    city: 'Wynnewood',
    popupId: '#popmake-2904',
    identifier: 'Main Line (Wynnewood)',
    newIdentifier: 'Main Line Adult (Wynnewood)'
  },
  {
    name: 'Maui Home Care',
    city: 'Wailuku',
    popupId: '#popmake-3117',
    identifier: 'Wailuku, HI',
    newIdentifier: 'Maui Home Care  (Wailuku)'
  },
  {
    name: 'Media',
    city: 'Media',
    popupId: '#popmake-2906',
    identifier: 'Media',
    newIdentifier: 'Media (Media)'
  },
  {
    name: 'Mercer County Assistive Care',
    city: 'Hamilton',
    popupId: '#popmake-2880',
    identifier: 'Mercer County Assistive Care (Hamilton)',
    newIdentifier: 'Mercer County Assistive Care (Hamilton)'
  },
  {
    name: 'Middlesex Assistive Care',
    city: 'East Brunswick',
    popupId: '#popmake-2882',
    identifier: 'Middlesex Assistive Care (North Brunswick)',
    newIdentifier: 'Middlesex Assistive Care (East Brunswick)'
  },
  {
    name: 'Morristown',
    city: 'Morristown',
    popupId: '#popmake-2884',
    identifier: 'Morristown',
    newIdentifier: 'Morristown (Morristown)'
  },
  {
    name: 'New York Assistive Care',
    city: 'New York',
    popupId: '#popmake-2900',
    identifier: 'New York Assistive Care (New York)',
    newIdentifier: 'New York Assistive Care (New York)'
  },
  {
    name: 'Newton',
    city: 'Auburndale',
    popupId: '#popmake-2853',
    identifier: 'Newton (Auburndale)',
    newIdentifier: 'Newton (Auburndale)'
  },
  {
    name: 'Oahu Home Care',
    city: 'Honolulu',
    popupId: '#popmake-2843',
    identifier: 'Oahu Home Care (Honolulu)',
    newIdentifier: 'Oahu Home Care (Honolulu)'
  },
  {
    name: 'Orlando',
    city: 'Winter Park',
    popupId: '#popmake-2835',
    identifier: 'Orlando (Winter Park)',
    newIdentifier: 'Orlando (Winter Park)'
  },
  {
    name: 'Orlando South Assistive Care',
    city: 'Orlando',
    popupId: '#popmake-2837',
    identifier: 'Orlando South Assistive Care (Orlando)',
    newIdentifier: 'Orlando South Assistive Care (Orlando)'
  },
  {
    name: 'Philadelphia',
    city: 'Philadelphia',
    popupId: '#popmake-2908',
    identifier: 'Philadelphia',
    newIdentifier: 'Philadelphia (Philadelphia)'
  },
  {
    name: 'Pinellas County',
    city: 'Saint Petersburg',
    popupId: '#popmake-2839',
    identifier: 'Pinellas County (Saint Petersburg)',
    newIdentifier: 'Pinellas County (Saint Petersburg)'
  },
  {
    name: 'Plymouth',
    city: 'Plymouth',
    popupId: '#popmake-2855',
    identifier: 'Plymouth',
    newIdentifier: 'Plymouth (Plymouth)'
  },
  {
    name: 'Rhode Island Assistive Care',
    city: 'Warwick',
    popupId: '#popmake-2912',
    identifier: 'Rhode Island Assistive Care (Warwick)',
    newIdentifier: 'Rhode Island Assistive Care (Warwick)'
  },
  {
    name: 'Richmond Virginia Assistive Care',
    city: 'Richmond',
    popupId: '#popmake-2916',
    identifier: 'Richmond Virginia Assistive Care (Richmond)',
    newIdentifier: 'Richmond Virginia Assistive Care (Richmond)'
  },
  {
    name: 'Southern Delaware Assistive Care',
    city: 'Milford',
    popupId: '#popmake-2833',
    identifier: 'Southern Delaware Assistive Care (Milford)',
    newIdentifier: 'Southern Delaware Assistive Care (Milford)'
  },
  {
    name: 'Southern New Jersey Live-In',
    city: 'Pennsauken Township',
    popupId: '#popmake-2888',
    identifier: 'Southern New Jersey Live In (Cherry Hill)',
    newIdentifier: 'Southern New Jersey Live-In (Pennsauken Township)'
  },
  {
    name: 'Tampa Assistive Care',
    city: 'Tampa',
    popupId: '#popmake-2841',
    identifier: 'Tampa Assistive Care (Tampa)',
    newIdentifier: 'Tampa Assistive Care (Tampa)'
  },
  {
    name: 'Tempe',
    city: 'Scottsdale',
    popupId: '#popmake-2823',
    identifier: 'Tempe',
    newIdentifier: 'Tempe (Scottsdale)'
  },
  {
    name: 'Toms River Assistive Care',
    city: 'Toms River',
    popupId: '#popmake-2892',
    identifier: 'Toms River Assistive Care (Toms River)',
    newIdentifier: 'Toms River Assistive Care (Toms River)'
  },
  {
    name: 'Tucson East Adult',
    city: 'Tucson',
    popupId: '#popmake-2825',
    identifier: 'Tucson East (Tucson)',
    newIdentifier: 'Tucson East Adult (Tucson)'
  },
  {
    name: 'Tucson West Adult',
    city: 'Tucson',
    popupId: '#popmake-2827',
    identifier: 'Tucson West (Tucson)',
    newIdentifier: 'Tucson West Adult (Tucson)'
  },
  {
    name: 'West Chester PA Assistive Care',
    city: 'West Chester',
    popupId: '#popmake-3210',
    identifier: 'West Chester PA',
    newIdentifier: 'West Chester PA Assistive Care (West Chester)'
  },
  {
    name: 'Westfield',
    city: 'Westfield',
    popupId: '#popmake-2894',
    identifier: 'Westfield',
    newIdentifier: 'Westfield (Westfield)'
  },
  {
    name: 'Williamsburg',
    city: 'Williamsburg',
    popupId: '#popmake-2918',
    identifier: 'Williamsburg',
    newIdentifier: 'Williamsburg (Williamsburg)'
  },
  {
    name: 'Willow Grove',
    city: 'Willow Grove',
    popupId: '#popmake-2910',
    identifier: 'Willow Grove',
    newIdentifier: 'Willow Grove (Willow Grove)'
  },
  {
    name: 'Winston-Salem Assistive Care',
    city: 'Winston Salem',
    popupId: '#popmake-2867',
    identifier: 'Winston Salem Assistive Care (Winston Salem)',
    newIdentifier: 'Winston-Salem Assistive Care (Winston Salem)'
  }
];
